/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IndicatorDetails } from './indicatorDetails';
import { IndicatorScorecard } from './indicatorScorecard';


/**
 * Indicator Scorecard details
 */
import { ValidateUtils } from 'app/shared/utils';

export class IndicatorScorecardDetails { 
    indicatorScorecard?: IndicatorScorecard;
    /**
     * Indicators (filtered by scorecard)
     */
    indicators?: Array<IndicatorDetails>;

    constructor(item?: Partial<IndicatorScorecardDetails>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            indicatorScorecard: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.indicatorScorecard : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            indicators: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.indicators : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: IndicatorScorecardDetails.isValid,
        };
    }

    static isValid(obj: IndicatorScorecardDetails): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = IndicatorScorecardDetails.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.indicatorScorecard.isValid(item);
            result = result && validationObject.indicators.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

